/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
app.helpers = app.helpers || {};

(function () {
  'use strict';
  /**
   * Хэлпер для отправки в ОКО.
   * @type {{push: app.helpers.OkoHelper.push, awaitPush: app.helpers.OkoHelper.awaitPush}}
   */
  app.helpers.OkoHelper = {
    /**
     * Максимальная задержка отправки события на ОКО.
     */
    OKO_MAX_DELAY: 1000,
    /**
     * Отправляет в око переданный объект с данными.
     * @param obj
     */
    push: function (obj) {
      var okoObj = [];
      if (typeof oko !== 'undefined') {
        okoObj = oko;
      }
      okoObj.push(obj);
    },
    /**
     * Отправляет в око переданный объект с данными и выполняет колбэк
     * после успешной отправки.
     * @param {Object} obj Объект с данными события.
     * @param {Function} callback Callback при любом ответе.
     * @param {Number} [callThroughTimeout] Принудительно вызвать callback через n миллисекунд.
     */
    awaitPush: function (obj, callback, callThroughTimeout) {
      callThroughTimeout = callThroughTimeout || this.OKO_MAX_DELAY;
      var isCallbackCalled = false;

      var prepareCallback = function () {
        if (!isCallbackCalled) {
          isCallbackCalled = true;
          callback();
        }
      };
      this.push(obj);
      document.querySelector('script[src*="oko."]').onload = function () {
        if (typeof callback === 'function') {
          prepareCallback();
        }
      };
      if (callThroughTimeout) {
        setTimeout(prepareCallback, callThroughTimeout);
      }
    },
    /**
     * Подписать изменение суммы корзины в oko на изменение корзины.
     * @param {app.Cart} cart Коллекция корзины.
     */
    connectCartToOko: function (cart) {
      if (cart) {
        cart.on('update', this.updateOkoInfo);
        this.updateOkoInfo(cart);
      }
    },
    /**
     * Обновить информацию в oko.info.
     * @param {Object} data Коллекция данных.
     */
    updateOkoInfo: function (data) {
      var cartSum = data && data.cartInfo && data.cartInfo.sum;
      var settlementId = data && data.id;
      var okoInfo = window.oko && window.oko.info;

      if (typeof cartSum === 'number' && okoInfo){
        okoInfo['cart-sum'] = cartSum;
      }
      if (typeof settlementId === 'number' && okoInfo){
        okoInfo['settlement-id'] = settlementId;
      }
    },
  };
})();

}.call(window));